export interface LabelPlacement {
  id: string;
  key: string;
  description: string;
}
